export default {
  setAll(state, data) {
    state.all = data
  },
  setGroupProduct(state, data) {
    state.gourpByProducts = data
  }
};